import K18nUtils from '@k18n/k18n-utils';
import { lang } from './const';

// k18n
let k18n: any;

function mergeUnloadLangs() {
    const win = (globalThis || window) as any;
    console.log('inject k18n list =>', win?.__k18nUtilsNotLoadList?.length);
    if (win?.__k18nUtilsNotLoadList?.length) {
        win.__k18nUtilsNotLoadList.forEach(message => {
            k18n.addMessages(message);
        });
        // win.__k18nUtilsNotLoadList = null;
    }
}

// 实例化K18n
export function createK18n(message) {
    if (k18n) return k18n;
    // 实例化K18n
    k18n = new K18nUtils({
        messages: [message].filter(Boolean),
        locale: lang,
    });
    mergeUnloadLangs();
    return k18n;
}
export const $k18n = (params: string | { text?: string; key?: string; id?: string; desc?: string; params?: Record<string, any> }): string => {
    if (typeof params === 'string') {
        return k18n.getText({
            text: params,
        });
    }
    return k18n.getText(params);
};

// rtl语言
const rtlLang = ['ar', 'ur'];

export const $isRtl = () => {
    return rtlLang.includes(k18n.locale);
};

// webpack 模式下，在相关时机初始化 k18n 即可
export function initK18n() {
    if (k18n) return k18n;
    // 实例化K18n
    k18n = new K18nUtils({
        messages: [],
        locale: lang,
    });
    mergeUnloadLangs();
    return k18n;
}
